import React, { useEffect, useState, useRef } from 'react';
import Store from "../store/Store";
import Select from "react-select";
import Api from "../api/Api";
import '../css/new-task.css'
import { Link, useParams } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Tooltip, Container } from "react-bootstrap";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons"
// import { faCircle } from '@fortawesome/free-regular-svg-icons';  // Üres kör importálása

export default (props) => {
    const {table_id} = useParams(); 
    const storeState = Store.getState();
    const [requiredFields, setRequiredFields] = useState([]);

    // console.log("REDUX állapot: ",storeState);

    let { tables, farms, operations, harvestYears, actualHarvestYear, groupedYears } = Store.getState();
    const groupedParcels = storeState.groupedParcels || {}; // Ha nincs még betöltve, üres objektum legyen

    //console.log("groupedParcels: ",groupedParcels);

    let selectedTable = null; // ha kapunk url ben Táblacsoport id-t akkor beállítjuk azt
    let tableOptions = [];
    tables.forEach(item => {
        tableOptions.push({ value: item.table_id, label: item.name });
        if(item.table_id == table_id){
            selectedTable = [{ value: item.table_id, label: item.name }];
        }
    });
   
    let _guid = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16).toUpperCase());
    const { user } = Store.getState();


    if (!user?.permissions?.includes('pwaCreateTask')) {
        return (
            <>
                <div className='new-task'>
                    <div className={"page-head my-2 d-flex"}>
                        <h3 className="title"><strong>Hiba</strong></h3>
                        <div>
                            <Link to={"/"} className={"btn button"}><FontAwesomeIcon icon="fa-solid fa-chevron-left" />{" Vissza"} </Link>
                        </div>
                    </div>
                    <div>
                        <div>
                            Nincs jogosultsága ehhez az oldalhoz.
                        </div>
                    </div>                    
                </div>
            </>
        );
    }


    const [myState, setMyState] = useState({
        guid: _guid,
        name: null,
        harvest_year_id: null,
        table_id: selectedTable ? [selectedTable] : [],
        parcels: [],
        selectedParcels: [],
        farm_id: farms.length === 1 ? { value: farms[0].id, label: farms[0].name } : null,
        operation_id: null,
        started_at: null,
        completed_at: null,
        dirty: 1,
        harvest_year_name: null,
        id: null,
        sub_tasks: [{ user_id: user.id }],
        task_area: '',
        task_cost: '',
        note: '',
        image: '',
    });
    const [changed,setChanged] = useState(0);
    let farmOptions = [];
    farms.forEach(item => {
        farmOptions.push({ value: item.id, label: item.name });
    });
    let harvestYearOptions = [];
    harvestYears.forEach(item => {
        harvestYearOptions.push({ value: item.id, label: item.name });
    });
    let operationOptions = [];
    operations.forEach(item => {
        if (myState.farm_id && myState.farm_id.value) {
            if (Number(item.farm_id) === Number(myState.farm_id.value)) {
                operationOptions.push({ value: item.id, label: item.name });
            }
        } else {
            operationOptions.push({ value: item.id, label: item.name });
        }
    });

    let selectedFarm = null;
    let selectedHarvestYear = null;

    for (const [farmName, years] of Object.entries(groupedYears)) {
        for (const [yearId, label] of Object.entries(years)) {
            if (Number(yearId) === Number(actualHarvestYear)) {
                selectedFarm = farmOptions.find(f => f.label === farmName);
                selectedHarvestYear = { value: Number(yearId), label };
                break;
            }
        }
        if (selectedFarm) break;
    }

    useEffect(() => {
        if (selectedFarm && selectedHarvestYear) {
            setMyState(prev => {
                // csak ha még nem egyezik
                if (prev.farm_id !== selectedFarm.value || prev.harvest_year_id !== selectedHarvestYear.value) {
                    return {
                        ...prev,
                        farm_id: selectedFarm,
                        harvest_year_id: selectedHarvestYear
                    };
                }
                return prev; // változtatás nélkül → nem update-el
            });
        }
    }, [selectedFarm?.value, selectedHarvestYear?.value]); 

    // Ha megváltozik a kiválasztott tábla, frissítsük a parcellákat
    useEffect(() => {
        if (myState.table_id.length > 0) {
            let selectedTableIds = myState.table_id.map(t => t.value);
            console.log(myState.table_id);
            let selectedParcels = [];

            selectedTableIds.forEach(id => {
                if (groupedParcels[id]) {
                    groupedParcels[id].forEach(parcel => {
                        selectedParcels.push({ value: parcel.parcel_id, label: parcel.parcel_name });
                    });
                }
            });
            
            setMyState(prevState => ({ ...prevState, parcels: selectedParcels, selectedParcels: selectedParcels }));
        } else {
            setMyState(prevState => ({ ...prevState, parcels: [], selectedParcels: [] }));
        }
        setChanged(changed+1);

    }, [myState.table_id]);

    // Név előálltás táblacsoport és művelet alapján
    useEffect(() => {
        let operationName = myState.operation_id ? myState.operation_id.label : "";
        let tableNames = myState.table_id.length > 0 
            ? myState.table_id.map(t => t.label).join(", ") 
            : "";
    
        let newName = operationName && tableNames ? `${operationName} - ${tableNames}` 
                     : operationName || tableNames || "";
    
        setMyState(prevState => ({ ...prevState, name: newName }));
    }, [myState.table_id, myState.operation_id]);



    const setInputValue = (property, val) => {
        setMyState(prev => ({
            ...prev,
            [property]: val
        }));
        setChanged(prev => prev + 1);

        console.log("---"); 
        console.log('input changed: "'+property+'" value:', val); 
        console.log("---end of value---");
    };

    const submitData = async (dest) => {
        let missingFields = [];

        console.log(myState);

        if (!myState.harvest_year_id || !myState.harvest_year_id.value) missingFields.push("harvest_year_id");
        if (!myState.name) missingFields.push("name");
        if (!myState.farm_id || !myState.farm_id.value) missingFields.push("farm_id");
        if (!myState.table_id || myState.table_id.length === 0) missingFields.push("table_id");
        if (!myState.operation_id || !myState.operation_id.value) missingFields.push("operation_id");
        if (!myState.started_at) missingFields.push("started_at");

        if (missingFields.length > 0) {
            setRequiredFields(missingFields);
            alert("Töltsd ki a kötelező mezőket!");
            return;
        }

        setRequiredFields([]); // Ha minden mező ki van töltve, töröljük a hibajelzéseket

        let task = myState;
        
        let { actualHarvestYear } = Store.getState();
        // postData létrehozása az adatokkal
        let postData = {
            guid: myState.guid,
            name: myState.name,
            started_at: myState.started_at,
            completed_at: myState.completed_at,
            farm_id: myState.farm_id ? Number(myState.farm_id.value) : null,
            harvest_year_id: myState.harvest_year_id ? Number(myState.harvest_year_id.value) : actualHarvestYear,
            operation_id: myState.operation_id ? Number(myState.operation_id.value) : null,
            table_id: myState.table_id ? myState.table_id.map(item => item.value) : [],
            parcel_id: myState.selectedParcels ? myState.selectedParcels.map(item => item.value) : [],
            note: myState.note ? myState.note : null,
            image: myState.image ? myState.image : null,
        };

        if (postData.name 
            && postData.farm_id 
            && postData.table_id 
            && postData.operation_id
            && postData.harvest_year_id
        ) {

            if (window.confirm('Biztosan menti az új feladatot?')) {
                let param = {
                    id: myState.guid,
                    task: postData
                }

                try {
                    const response = await Api.updateTask(param);
                    if (response === false || response?.error) { 
                        alert("Hiba történt a mentés során!");
                        return; // Megakadályozza az átirányítást
                    }
    
                    if (dest === "edit-task") {
                        window.location.assign("/edit-task/" + task.guid);
                    } else if (dest === "new-task") {
                        window.location.assign("/new-task"); 
                    }
                } catch (error) {
                    alert("Hálózati vagy szerverhiba történt!");
                    console.error(error);
                }

            }
        } else {
            console.warn("Hiányzó adatok a postData objektumban:", postData)
            alert('A mezők kitöltése kötelező!');
        }

    }


    
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            border: requiredFields.includes(state.selectProps.inputId.replace("new-task-", "")) 
                ? "1px solid red" 
                : "1px solid #ccc",
            background: requiredFields.includes(state.selectProps.inputId.replace("new-task-", "")) 
                ? "#ffe6e6" 
                : "rgba(249, 251, 247, 0.90);",
            "&:hover": {
                border: requiredFields.includes(state.selectProps.inputId.replace("new-task-", "")) 
                    ? "1px solid red" 
                    : "1px solid #aaa"
            }
        })
    }

    const farmHelp = () => (
    <OverlayTrigger
        placement="right"
        overlay={
        <Tooltip id="farm-tooltip">
            A menüben kiválasztott Gazdaságra és Aratási évre lehet létrehozni új feladatot.
        </Tooltip>
        }
    >
        <span className="ms-2 text-secondary" style={{ cursor: "pointer" }}>
        <FontAwesomeIcon icon={faInfoCircle} />
        </span>
    </OverlayTrigger>
    );
  
    const customInputStyle = (field) => ({
        border: requiredFields.includes(field) ? "1px solid red" : "",
        backgroundColor: requiredFields.includes(field) ? "#ffe6e6" : "",
    });

    return (
        <>
            <div className='new-task'>
                <div className={"page-head my-2 d-flex"}>
                    <h3 className="title"><strong>Új feladat</strong></h3>
                    <div>
                        <Link to={"/"} className={"btn button"}><FontAwesomeIcon icon="fa-solid fa-chevron-left" />{" Vissza"} </Link>
                    </div>
                </div>
                <div className='input-holder'>
                    <label htmlFor="new-task-farm_id">Gazdaság {farmHelp()}</label>
                    <Select
                        styles={customStyles}
                        className="pwa-select-container"
                        classNamePrefix="pwa-select"
                        inputId={'new-task-farm_id'}
                        value={ myState.farm_id}
                        options={farmOptions}
                        isDisabled={true}
                        onChange={(val) => setInputValue('farm_id', val)}
                    />
                </div>
                <div className='input-holder'>
                    <label htmlFor="new-task-harvest_year_id">Aratási év {farmHelp()}</label>
                    <Select
                        styles={customStyles}
                        className="pwa-select-container"
                        classNamePrefix="pwa-select"
                        inputId={'new-task-harvest_year_id'}
                        value={selectedHarvestYear}
                        options={harvestYearOptions.filter(opt => opt.label.includes(selectedFarm.label))}
                        isDisabled={true}
                        onChange={(val) => setInputValue('harvest_year_id', val)}
                    />
                </div>
                <div className='input-holder'>
                    <label htmlFor="new-task-table_id">Táblacsoportok</label>
                    <Select
                        styles={customStyles}
                        className="pwa-select-container"
                        classNamePrefix="pwa-select"
                        inputId={'new-task-table_id'}
                        isMulti={true}
                        value={myState.table_id}
                        options={tables.map(t => ({ value: t.table_id, label: t.name }))}
                        onChange={(val) => setInputValue("table_id", val)}
                    />
                </div>
                <div className='input-holder'>
                    <label htmlFor="new-task-parcel_id">Táblák</label>
                    <Select
                        styles={customStyles}
                        className="pwa-select-container"
                        classNamePrefix="pwa-select"
                        inputId={'new-task-parcel_id'}
                        isMulti={true}
                        value={myState.selectedParcels}
                        options={myState.parcels}
                        onChange={(val) => {
                            setInputValue("selectedParcels", val);
                            //setMyState(prevState => ({ ...prevState, parcels: val }));
                        }}
                    />

                </div>
                <div className='input-holder'>
                    <label htmlFor="new-task-operation_id">Művelet</label>
                    <Select
                        className="pwa-select-container"
                        classNamePrefix="pwa-select"
                        styles={customStyles}
                        inputId={'new-task-operation_id'}
                        value={myState.operation_id ? myState.operation_id : 0}
                        options={operationOptions}
                        onChange={(val) => setInputValue( 'operation_id', val )}
                    />
                </div>
                <div className='input-holder'>
                    <label htmlFor="new-task-name">Név</label>
                    <input
                        // styles={customStyles}
                        className="input new-task-input"
                        type="text"
                        placeholder="Név"
                        value={myState.name ? myState.name : ''}
                        style={customInputStyle("name")}
                        onChange={(e) => setInputValue('name', e.target.value)}
                    />
                </div>
                <div className='input-holder'>
                    <label htmlFor="new-task-started_at">Kezdődátum</label>
                    <input
                        // styles={customStyles}
                        id="new-task-started_at"
                        className="input new-task-input"
                        type="date"
                        value={myState.started_at ? myState.started_at : ''}
                        style={customInputStyle("started_at")}
                        onChange={(e) => setInputValue('started_at', e.target.value)}
                    />
                </div>
                <div className='input-holder'>
                    <label htmlFor="new-task-completed_at">Befejezés ideje</label>
                    <input
                        id="new-task-completed_at"
                        className="input new-task-input"
                        type="date"
                        value={myState.completed_at ? myState.completed_at : ''}
                        onChange={(e) => setInputValue('completed_at', e.target.value)}
                    />
                </div>
                <div className='input-holder'>
                    <div >
                        <label className="radio-label">
                            <input
                                className="me-1"
                                type="radio"
                                name="croptype"
                                value="maincrop"
                                checked={myState.croptype === "maincrop"}
                                onChange={(e) => setInputValue('croptype', e.target.value)}
                            />
                            Fővetés
                        </label>
                        <label className="radio-label">
                            <input
                                className="me-1"
                                type="radio"
                                name="croptype"
                                value="secondcrop"
                                checked={myState.croptype === "secondcrop"}
                                onChange={(e) => setInputValue('croptype', e.target.value)}
                            />
                            Másodvetés
                        </label>
                    </div>
                </div>
                <Container className="new-task-note-block mt-3 py-2">
                    <label className="">Megjegyzés írása</label>
                    <textarea onBlur={(e) => setInputValue('note', e.target.value)} name="note" className="my-2 p-2" placeholder="Írj egy megjegyzést..."></textarea>

                    <div className="note-file-input-outer my-2">
                        <input onChange={(e) => setInputValue('image', e.target.files[0])} type="file" name="image" className="note-file-input" accept="image/*" capture="environment"></input>
                    </div>
                </Container>
                <div className="my-4">
                    <button className="btn button w-100 h50 mb-3" onClick={() => submitData("edit-task")}>
                        Feladat létrehozása
                    </button>
                    <button className="btn button w-100 h50" onClick={() => submitData("new-task")}>
                        Létrehozás és folytatás
                    </button>
                </div>
                {/* <button className={"btn button align-self-end mt-2"} onClick={submitData}>Feladat létrehozása</button> */}
            </div>
        </>
    );

}
